import { render } from "./BasePopup.vue?vue&type=template&id=75ba841e&ts=true"
import script from "./BasePopup.vue?vue&type=script&lang=ts"
export * from "./BasePopup.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/vav/Dev/eco-lk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__